import React from "react";
import {
  Box,
  Card,
  Grid,
  IconButton,
  Typography,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  Tooltip,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import DeleteIcon from "../../../../common/customIcons/delete";
import MDButton from "../../../../components/MDButton";
import { openCustomModalDialog } from "../../../../redux/slices/modalSlice";
import EditableAccordionHeader from "../components/EditableAccordionHeader";

const thumbnailCloseIcon = {
  backgroundColor: "#FD4438",
  borderRadius: 10,
  p: 0.25,
  mt: -4,
  mr: -4,
  cursor: "pointer",
};

function CategorySection({
  categoryOpen,
  setCategoryOpen,
  formData = {},
  handleSave,
  setFormData,
  errors = {},
  setErrors,
  allCategoryData,
  handleRemoveCategory,
  handleAddCategory,
  allCategoriesSelected,
  gridConfigs,
  removeImageHandler,
  dispatch,
  sliderLength,
  sliderMobileLength,
  // Heading editing props
  sectionHeading,
  isEditingHeading,
  tempHeadingValue,
  setTempHeadingValue,
  onEditHeading,
  onSaveHeading,
  onCancelHeading,
}) {
  return (
    <Accordion expanded={categoryOpen} onChange={() => setCategoryOpen(!categoryOpen)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panelcategory-content"
        id="panelcategory-header"
      >
        <EditableAccordionHeader
          sectionKey="categorySection"
          heading={sectionHeading}
          isEditing={isEditingHeading}
          tempValue={tempHeadingValue}
          setTempValue={setTempHeadingValue}
          onEdit={onEditHeading}
          onSave={onSaveHeading}
          onCancel={onCancelHeading}
        />
      </AccordionSummary>
      <AccordionDetails>
        {formData?.categorySection?.map((card, index) => {
          return (
            <Card
              key={card?.arrayIndex}
              sx={{
                p: { xs: 2, md: 3 },
                borderRadius: 2.5,
                boxShadow: "none",
                backgroundColor: "#F5F5FF",
                marginBottom: "15px",
                position: "relative",
              }}
              className="repeat-card"
            >
              {/* {formData?.categorySection?.length > 1 && card?.arrayIndex !== 0 && ( */}
              <IconButton
                onClick={() => handleRemoveCategory(card?.arrayIndex)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 1,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                  },
                }}
                color="error"
                size="small"
              >
                <DeleteIcon width="16px" height="16px" />
              </IconButton>
              {/* )} */}
              <Grid container direction="row" spacing={4}>
                <Grid item xs={12}>
                  <Grid container direction="row" spacing={4}>
                    <Grid item xs={12} md={6}>
                      <Box style={{ width: "100%" }}>
                        {/* <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Select Category</Typography> */}
                        <FormControl fullWidth>
                          <InputLabel>Select Category</InputLabel>
                          <Select
                            className="form-select select-field-icon"
                            label="Select Category"
                            name={`categorySection[${card?.arrayIndex}].categoryName`}
                            value={card.categoryName || ""}
                            onChange={(e) => {
                              const selectedCategoryName = e.target.value;

                              // Find the selected item from allCategoryData to get its categoryId
                              const selectedItem = allCategoryData?.values?.find(
                                (item) => item.categoryName === selectedCategoryName
                              );
                              const selectedCategoryId = selectedItem?._id || "";

                              setFormData((prev) => {
                                const updatedCategorySection = prev.categorySection.map((section) =>
                                  section.arrayIndex === card.arrayIndex
                                    ? {
                                        ...section,
                                        categoryName: selectedCategoryName,
                                        categoryId: selectedCategoryId,
                                      }
                                    : section
                                );
                                return {
                                  ...prev,
                                  categorySection: updatedCategorySection,
                                };
                              });
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                [`categorySection[${card?.arrayIndex}].categoryName`]: "",
                              }));
                            }}
                          >
                            {allCategoryData?.values?.map((item, index) => {
                              // Check if category is already selected in another card
                              const isCategoryAdded = formData?.categorySection?.some(
                                (section) =>
                                  section.categoryName === item.categoryName &&
                                  section.arrayIndex !== card.arrayIndex
                              );
                              return (
                                <MenuItem
                                  key={index}
                                  value={item.categoryName}
                                  disabled={isCategoryAdded}
                                >
                                  {item.categoryName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {Boolean(errors[`categorySection[${card?.arrayIndex}].categoryName`]) && (
                            <FormHelperText error>
                              {errors[`categorySection[${card?.arrayIndex}].categoryName`]}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ width: "100%" }}>
                    <Typography
                      variant="body2"
                      fontWeight="medium"
                      color="#9A9AAF"
                      mb={1}
                      style={{ fontSize: "14px" }}
                    >
                      Bento Grid First Heading (H2)
                    </Typography>
                    <TextField
                      label=""
                      className="form-input"
                      fullWidth
                      name={[`categorySection[${card?.arrayIndex}].bentoGridHeading`]}
                      error={errors[`categorySection[${card?.arrayIndex}].bentoGridHeading`]}
                      helperText={errors[`categorySection[${card?.arrayIndex}].bentoGridHeading`]}
                      placeholder=""
                      value={card.bentoGridHeading}
                      onChange={(e) => {
                        setFormData((prev) => {
                          const updatedCategorySection = prev.categorySection.map((section) =>
                            section.arrayIndex === card.arrayIndex
                              ? { ...section, bentoGridHeading: e.target.value }
                              : section
                          );
                          return {
                            ...prev,
                            categorySection: updatedCategorySection,
                          };
                        });
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          [`categorySection[${card?.arrayIndex}].bentoGridHeading`]: "",
                        }));
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box style={{ width: "100%" }}>
                    <Typography
                      variant="body2"
                      fontWeight="medium"
                      color="#9A9AAF"
                      mb={1}
                      style={{ fontSize: "14px" }}
                    >
                      Bento Grid Second Heading (H2)
                    </Typography>
                    <TextField
                      label=""
                      className="form-input"
                      fullWidth
                      // name={[`categorySection[${card?.arrayIndex}].bentoGridHeading`]}
                      // error={errors[`categorySection[${card?.arrayIndex}].bentoGridHeading`]}
                      // helperText={errors[`categorySection[${card?.arrayIndex}].bentoGridHeading`]}
                      placeholder=""
                      value={card.bentoGridHeading1}
                      onChange={(e) => {
                        setFormData((prev) => {
                          const updatedCategorySection = prev.categorySection.map((section) =>
                            section.arrayIndex === card.arrayIndex
                              ? { ...section, bentoGridHeading1: e.target.value }
                              : section
                          );
                          return {
                            ...prev,
                            categorySection: updatedCategorySection,
                          };
                        });
                        // setErrors((prevErrors) => ({
                        //   ...prevErrors,
                        //   [`categorySection[${card?.arrayIndex}].bentoGridHeading`]: "",
                        // }));
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Select Grid
                    <Tooltip
                      title={
                        <Typography variant="body2" fontWeight="500" className="text-12 py-2">
                          Notes: All grids: No Grid (0), Two Column-Left (3), Two Column-Right (3),
                          Full Width (1), Stacked Grid (3), Two Column (2), Equal (2), Triple Grid
                          (3), Slider (multi).
                        </Typography>
                      }
                      arrow
                      placement="top"
                    >
                      <InfoOutlinedIcon
                        color="#2E2E3A"
                        style={{
                          color: "#2E2E3A",
                          marginLeft: "5px",
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    </Tooltip>
                  </Typography>
                  <Box sx={{ width: "100%" }} className="select-grid-tabs">
                    <TabContext value={card.layoutType}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          value={card.layoutType || "No Grid"}
                          onChange={(event, newValue) => {
                            // Prevent re-selecting the already active tab
                            if (card.layoutType === newValue) return;
                            setFormData((prev) => {
                              const updatedCategorySection = prev.categorySection.map((section) =>
                                section.arrayIndex === card.arrayIndex
                                  ? { ...section, layoutType: newValue }
                                  : section
                              );
                              return {
                                ...prev,
                                categorySection: updatedCategorySection,
                              };
                            });
                          }}
                          aria-label="lab API tabs example"
                        >
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <path
                                      d="M15 29C22.7192 29 29 22.7198 29 15C29 11.2573 27.5445 7.74109 24.9016 5.09843C22.2583 2.45548 18.7427 1 15 1C7.28023 1 1 7.28023 1 15C1 18.7427 2.45548 22.2589 5.09843 24.9016C7.74109 27.5445 11.2573 29 15 29ZM15 26.6667C12.2736 26.6667 9.69161 25.7398 7.61377 24.036L24.036 7.61377C25.7398 9.69161 26.6667 12.2736 26.6667 15C26.6667 21.4329 21.4329 26.6667 15 26.6667ZM15 3.33333C17.7258 3.33333 20.3084 4.26017 22.3857 5.96403L5.96403 22.3862C4.26017 20.3084 3.33333 17.7264 3.33333 15C3.33333 8.5671 8.5671 3.33333 15 3.33333Z"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  No Grid
                                </Typography>
                              </Box>
                            }
                            value="No Grid"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      width="21"
                                      height="41"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="24"
                                      width="40"
                                      height="19"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="24"
                                      y="22"
                                      width="40"
                                      height="19"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Two Column-Left
                                </Typography>
                              </Box>
                            }
                            value="Two Column-Left"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      x="43"
                                      width="21"
                                      height="41"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      width="40"
                                      height="19"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      y="22"
                                      width="40"
                                      height="19"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Two Column-Right
                                </Typography>
                              </Box>
                            }
                            value="Two Column-Right"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      x="1"
                                      width="62"
                                      height="41"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Full Width
                                </Typography>
                              </Box>
                            }
                            value="Full Width"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="65"
                                    height="41"
                                    viewBox="0 0 65 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      y="2"
                                      width="64"
                                      height="16"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      y="21"
                                      width="30.5"
                                      height="18"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="34"
                                      y="21"
                                      width="30.5"
                                      height="18"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Stacked Grid
                                </Typography>
                              </Box>
                            }
                            value="Stacked Grid"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      y="2"
                                      width="40"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="43"
                                      y="2"
                                      width="21"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Two Column
                                </Typography>
                              </Box>
                            }
                            value="Two Column"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      y="2"
                                      width="30"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="33"
                                      y="2"
                                      width="31"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Equal
                                </Typography>
                              </Box>
                            }
                            value="Equal"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <rect
                                      y="2"
                                      width="20"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="23"
                                      y="2"
                                      width="19"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="45"
                                      y="2"
                                      width="19"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Triple Grid
                                </Typography>
                              </Box>
                            }
                            value="Triple Grid"
                          />
                          <Tab
                            label={
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                gap={0.5}
                              >
                                <Box className="tab-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="41"
                                    viewBox="0 0 64 41"
                                    fill="none"
                                    style={{ margin: "0" }}
                                  >
                                    <path
                                      d="M8 35C8 37.2091 6.20914 39 4 39L3.33786e-06 39L1.03217e-07 2L4 2C6.20914 2 8 3.79086 8 6L8 35Z"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <rect
                                      x="11"
                                      y="2"
                                      width="42"
                                      height="37"
                                      rx="4"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                    <path
                                      d="M56 6C56 3.79086 57.7909 2 60 2H64V39H60C57.7909 39 56 37.2091 56 35V6Z"
                                      fill="#0163FF"
                                      fillOpacity="0.24"
                                    />
                                  </svg>
                                </Box>
                                <Typography
                                  variant="body2"
                                  fontWeight="600"
                                  color="#8A8A98"
                                  style={{ fontSize: "12px" }}
                                >
                                  Slider
                                </Typography>
                              </Box>
                            }
                            value="Slider"
                          />
                        </TabList>
                      </Box>
                      <Grid container direction="row" spacing={2}>
                        <Grid item xs={12}>
                          <FormControl component="fieldset">
                            <Box display="flex" alignItems="center" gap={2} mt={1}>
                              <FormLabel
                                component="legend"
                                style={{
                                  fontSize: "14px",
                                  color: "#2E2E3A",
                                  fontWeight: "600",
                                }}
                              >
                                Use Default URL For grid
                              </FormLabel>
                              <FormGroup aria-label="position" row>
                                <FormControlLabel
                                  value="Use Default URL For grid"
                                  control={
                                    <Switch
                                      color="primary"
                                      checked={card.defaultRedirectUrlEnable || false}
                                      onChange={(e) => {
                                        const newValue = e.target.checked;
                                        setFormData((prev) => {
                                          const updatedCategorySection = prev.categorySection.map(
                                            (section) =>
                                              section.arrayIndex === card.arrayIndex
                                                ? {
                                                    ...section,
                                                    defaultRedirectUrlEnable: newValue,
                                                  }
                                                : section
                                          );
                                          return {
                                            ...prev,
                                            categorySection: updatedCategorySection,
                                          };
                                        });
                                      }}
                                    />
                                  }
                                />
                              </FormGroup>
                            </Box>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <Box style={{ maxWidth: "420px" }}>
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="#9A9AAF"
                              mb={1}
                              style={{ fontSize: "14px" }}
                            >
                              Add Default URL For Grid
                            </Typography>
                            <TextField
                              label=""
                              className="form-input"
                              fullWidth
                              placeholder=""
                              name={[`categorySection[${card?.arrayIndex}].defaultGridUrl`]}
                              error={errors[`categorySection[${card?.arrayIndex}].defaultGridUrl`]}
                              helperText={
                                errors[`categorySection[${card?.arrayIndex}].defaultGridUrl`]
                              }
                              value={card.defaultGridUrl || ""}
                              onChange={(e) => {
                                const val = e.target.value;
                                setFormData((prev) => {
                                  const updatedCategorySection = prev.categorySection.map(
                                    (section) =>
                                      section.arrayIndex === card.arrayIndex
                                        ? { ...section, defaultGridUrl: val }
                                        : section
                                  );
                                  return {
                                    ...prev,
                                    categorySection: updatedCategorySection,
                                  };
                                });
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  [`categorySection[${card?.arrayIndex}].defaultGridUrl`]: "",
                                }));
                              }}
                              disabled={!card.defaultRedirectUrlEnable}
                            />
                          </Box>
                        </Grid>
                      </Grid>

                      {/* {(() => {
                                                                         let gridMsg = "";
                                                                         // Define grid configuration
                                                                         if (card?.layoutType) {
                                                                             // Find matching grid config based on layoutType
                                                                             const currentConfig = gridConfigs.find(
                                                                                 (conf) => conf.key === card.layoutType
                                                                             );
                                                                             if (currentConfig) {
                                                                                 const requiredImages = currentConfig.value;
                                                                                 const gridImageCount = Array.isArray(card?.desktopGrid)
                                                                                     ? card.desktopGrid.filter((img) => img?.imageUrl).length
                                                                                     : 0;
                                                                                 if (gridImageCount < requiredImages) {
                                                                                     gridMsg = `All  desktop images are required`;
                                                                                 }
                                                                             }
                                                                         }
                                                                         return (
                                                                             Boolean(gridMsg) && <FormHelperText error>{gridMsg}</FormHelperText>
                                                                         );
                                                                     })()}
             
                                                                     {(() => {
                                                                         let gridMsg = "";
                                                                         // Define grid configuration
                                                                         if (card?.layoutType) {
                                                                             // Find matching grid config based on layoutType
                                                                             const currentConfig = gridConfigs.find(
                                                                                 (conf) => conf.key === card.layoutType
                                                                             );
                                                                             if (currentConfig) {
                                                                                 const requiredImages = currentConfig.value;
                                                                                 const gridImageCount = Array.isArray(card?.mobileGrid)
                                                                                     ? card.mobileGrid.filter((img) => img?.imageUrl).length
                                                                                     : 0;
                                                                                 if (gridImageCount < requiredImages) {
                                                                                     gridMsg = `All  mobile images are required`;
                                                                                 }
                                                                             }
                                                                         }
                                                                         return (
                                                                             Boolean(gridMsg) && <FormHelperText error>{gridMsg}</FormHelperText>
                                                                         );
                                                                     })()} */}

                      {/* <GridValidation
                                           key={card.id || index}
                                           card={card}
                                           cardId={card.id || `card-${index}`}
                                           gridConfigs={gridConfigs}
                                           onError={handleGridError}
                                         />
             
                                         {cardErrors[card.id || `card-${index}`] && (
                                           <Typography
                                             color="error"
                                             variant="body2"
                                             className="Mui-error"
                                             style={{ paddingTop: "3px", paddingLeft: "14px" }}
                                           >
                                           
                                             All images are required
                                           </Typography>
                                         )} */}
                      {/* No Grid */}
                      <TabPanel value="No Grid" style={{ padding: "30px 0 0 0" }}></TabPanel>

                      {/* Two Column-Left */}
                      <TabPanel value="Two Column-Left" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                  name=""
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="200px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card.desktopGrid.find(
                                          (item) => item.index === "1" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card.desktopGrid.find(
                                                  (item) => item.index === "1" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card.desktopGrid.find(
                                        (item) => item.index === "1" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.desktopGrid.find(
                                                    (item) => item.index === "1"
                                                  ),
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card.desktopGrid.find((item) => item.index === "1")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            maxWidth: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                maxWidth: "100%",
                                                minxHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card.desktopGrid.find(
                                              (item) => item.index === "3" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "3" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "3" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "3"
                                                      ),
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "3")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="200px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "1" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() => {
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "1" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "1" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.mobileGrid.find(
                                                    (item) => item.index === "1"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "1")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "3" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "3" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "3" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "3"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "3")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText rmHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Dekstop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Two Column-Right */}
                      <TabPanel value="Two Column-Right" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={8}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));

                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="200px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card?.desktopGrid.find(
                                          (item) => item.index === "3" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.desktopGrid.find(
                                                  (item) => item.index === "3" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card?.desktopGrid.find(
                                        (item) => item.index === "3" && item?.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.desktopGrid.find(
                                                    (item) => item.index === "3"
                                                  ),
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.desktopGrid.find((item) => item.index === "3")
                                              ?.imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={8}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "985x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="200px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "3" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() => {
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "3" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "3" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.mobileGrid.find(
                                                    (item) => item.index === "3"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "3")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Desktop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Full Width */}
                      <TabPanel value="Full Width" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={12}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="400px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card?.desktopGrid.find(
                                          (item) => item.index === "1" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.desktopGrid.find(
                                                  (item) => item.index === "1" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card?.desktopGrid.find(
                                        (item) => item.index === "1" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.desktopGrid.find(
                                                    (item) => item.index === "1"
                                                  ),
                                                  type: "Desktop",
                                                  dimensions: "1392x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.desktopGrid.find((item) => item.index === "1")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "1392x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              1392x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={12}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="400px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "1" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() => {
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "1" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "1" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.mobileGrid.find(
                                                    (item) => item.index === "1"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "1392x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "1")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "1392x600",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              1392x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Desktop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Stacked Grid */}
                      <TabPanel value="Stacked Grid" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={12}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="200px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card?.desktopGrid.find(
                                          (item) => item.index === "1" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.desktopGrid.find(
                                                  (item) => item.index === "1" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card?.desktopGrid.find(
                                        (item) => item.index === "1" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.desktopGrid.find(
                                                    (item) => item.index === "1"
                                                  ),
                                                  type: "Desktop",
                                                  dimensions: "1392x290",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.desktopGrid.find((item) => item.index === "1")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "200px",
                                            maxHeight: "200px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "1392x290",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              1392x290
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={12}>
                                    <Grid container direction="row" spacing={2}>
                                      <Grid item xs={12} md={6}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Desktop",
                                                      dimensions: "386x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "386x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "3" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "3" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "3" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "3"
                                                      ),
                                                      type: "Desktop",
                                                      dimensions: "386x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "3")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "386x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={12}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="200px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "1" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "1" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "1" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.mobileGrid.find(
                                                    (item) => item.index === "1"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "1392x290",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "1")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "200px",
                                            maxHeight: "200px",
                                            borderRadius: "16px",
                                            cursor: "pointer",
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "1392x290",
                                                  index: "1",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              1392x290
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={12}>
                                    <Grid container direction="row" spacing={2}>
                                      <Grid item xs={12} md={6}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "386x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "386x290",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="200px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "3" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "3" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "3" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "3"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "386x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "3")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "386x290",
                                                      index: "3",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x290
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Dekstop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Two Column */}
                      <TabPanel value="Two Column" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={8}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.desktopGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Desktop",
                                                      dimensions: "985x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "985x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="400px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card?.desktopGrid.find(
                                          (item) => item.index === "2" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.desktopGrid.find(
                                                  (item) => item.index === "2" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card?.desktopGrid.find(
                                        (item) => item.index === "2" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.desktopGrid.find(
                                                    (item) => item.index === "2"
                                                  ),
                                                  type: "Desktop",
                                                  dimensions: "386x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.desktopGrid.find((item) => item.index === "2")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={8}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card.mobileGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "985x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "985x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  985x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="416px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "2" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() => {
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "2" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "2" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card.mobileGrid.find(
                                                    (item) => item.index === "2"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "2")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Dekstop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Equal */}
                      <TabPanel value="Equal" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={6}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card?.desktopGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Desktop",
                                                      dimensions: "600x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "600x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  600x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="416px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card?.desktopGrid.find(
                                          (item) => item.index === "2" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.desktopGrid.find(
                                                  (item) => item.index === "2" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card?.desktopGrid.find(
                                        (item) => item.index === "2" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card?.desktopGrid.find(
                                                    (item) => item.index === "2"
                                                  ),
                                                  type: "Desktop",
                                                  dimensions: "600x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.desktopGrid.find((item) => item.index === "2")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "600x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              600x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={6}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card?.mobileGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "600x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "600x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  600x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="416px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "2" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() => {
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "2" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "2" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card?.mobileGrid.find(
                                                    (item) => item.index === "2"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "600x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "2")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "600x600",
                                                  index: "2",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              600x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Dekstop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Triple Grid */}
                      <TabPanel value="Triple Grid" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={4}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card?.desktopGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Dekstop",
                                                      dimensions: "386x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "386x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.desktopGrid) &&
                                            card?.desktopGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() =>
                                                  removeImageHandler(
                                                    card?.desktopGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "",
                                                    card?.arrayIndex
                                                  )
                                                }
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.desktopGrid) &&
                                          card?.desktopGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card?.desktopGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Dekstop",
                                                      dimensions: "386x600",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.desktopGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Dekstop",
                                                      dimensions: "386x600",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="416px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.desktopGrid) &&
                                        card?.desktopGrid.find(
                                          (item) => item.index === "3" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() =>
                                              removeImageHandler(
                                                card?.desktopGrid.find(
                                                  (item) => item.index === "3" && item.imageUrl
                                                ),
                                                "",
                                                card?.arrayIndex
                                              )
                                            }
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.desktopGrid) &&
                                      card?.desktopGrid.find(
                                        (item) => item.index === "3" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card?.desktopGrid.find(
                                                    (item) => item.index === "3"
                                                  ),
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.desktopGrid.find((item) => item.index === "3")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Dekstop",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={4}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "1" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "1" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "1" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card?.mobileGrid.find(
                                                        (item) => item.index === "1"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "386x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "1")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "386x600",
                                                      index: "1",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          borderRadius="16px"
                                          backgroundColor="#ffffff"
                                          height="100%"
                                          minHeight="416px"
                                          position="relative"
                                        >
                                          {Array.isArray(card?.mobileGrid) &&
                                            card?.mobileGrid.find(
                                              (item) => item.index === "2" && item.imageUrl
                                            ) && (
                                              <IconButton
                                                className="remove-icon"
                                                size="small"
                                                onClick={() => {
                                                  removeImageHandler(
                                                    card?.mobileGrid.find(
                                                      (item) => item.index === "2" && item.imageUrl
                                                    ),
                                                    "mobileGrid",
                                                    card?.arrayIndex
                                                  );
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          {Array.isArray(card?.mobileGrid) &&
                                          card?.mobileGrid.find(
                                            (item) => item.index === "2" && item.imageUrl
                                          ) ? (
                                            <img
                                              onClick={() => {
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      categoryData: card?.mobileGrid.find(
                                                        (item) => item.index === "2"
                                                      ),
                                                      type: "Mobile",
                                                      dimensions: "386x600",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                              src={
                                                card?.mobileGrid.find((item) => item.index === "2")
                                                  .imageUrl
                                              }
                                              alt="Desktop Grid"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                minHeight: "416px",
                                                maxHeight: "416px",
                                                borderRadius: "16px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <MDButton
                                              sx={{ minWidth: "180px" }}
                                              type="button"
                                              variant="outlined"
                                              color="secondary"
                                              component="span"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "0",
                                                border: "none",
                                                borderRadius: "0",
                                              }}
                                              onClick={() => {
                                                setErrors((prev) => ({
                                                  ...prev,
                                                  [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                    "",
                                                }));
                                                dispatch(
                                                  openCustomModalDialog({
                                                    modal: "ADD_GRID_BANNER",
                                                    modalData: {
                                                      type: "Mobile",
                                                      dimensions: "386x600",
                                                      index: "2",
                                                      arrayIndex: card?.arrayIndex,
                                                      handleSave: (data) => handleSave(data),
                                                    },
                                                  })
                                                );
                                              }}
                                            >
                                              <div className="add-change-img-sec">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="25"
                                                  viewBox="0 0 24 25"
                                                  fill="none"
                                                >
                                                  <g clipPath="url(#clip0_13676_49992)">
                                                    <path
                                                      d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                      fill="#2E2E3A"
                                                    />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_13676_49992">
                                                      <rect width="24" height="25" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="600"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Upload File
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  fontWeight="400"
                                                  color="#2E2E3A"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  386x600
                                                </Typography>
                                              </div>
                                            </MDButton>
                                          )}
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      height="100%"
                                      minHeight="416px"
                                      position="relative"
                                    >
                                      {Array.isArray(card?.mobileGrid) &&
                                        card?.mobileGrid.find(
                                          (item) => item.index === "3" && item.imageUrl
                                        ) && (
                                          <IconButton
                                            className="remove-icon"
                                            size="small"
                                            onClick={() => {
                                              removeImageHandler(
                                                card?.mobileGrid.find(
                                                  (item) => item.index === "3" && item.imageUrl
                                                ),
                                                "mobileGrid",
                                                card?.arrayIndex
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      {Array.isArray(card?.mobileGrid) &&
                                      card?.mobileGrid.find(
                                        (item) => item.index === "3" && item.imageUrl
                                      ) ? (
                                        <img
                                          onClick={() => {
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  categoryData: card?.mobileGrid.find(
                                                    (item) => item.index === "3"
                                                  ),
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                          src={
                                            card?.mobileGrid.find((item) => item.index === "3")
                                              .imageUrl
                                          }
                                          alt="Desktop Grid"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "416px",
                                            maxHeight: "416px",
                                            borderRadius: "16px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                          }}
                                        />
                                      ) : (
                                        <MDButton
                                          sx={{ minWidth: "180px" }}
                                          type="button"
                                          variant="outlined"
                                          color="secondary"
                                          component="span"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: "0",
                                            border: "none",
                                            borderRadius: "0",
                                          }}
                                          onClick={() => {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                "",
                                            }));
                                            dispatch(
                                              openCustomModalDialog({
                                                modal: "ADD_GRID_BANNER",
                                                modalData: {
                                                  type: "Mobile",
                                                  dimensions: "386x600",
                                                  index: "3",
                                                  arrayIndex: card?.arrayIndex,
                                                  handleSave: (data) => handleSave(data),
                                                },
                                              })
                                            );
                                          }}
                                        >
                                          <div className="add-change-img-sec">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="25"
                                              viewBox="0 0 24 25"
                                              fill="none"
                                            >
                                              <g clipPath="url(#clip0_13676_49992)">
                                                <path
                                                  d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                  fill="#2E2E3A"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_13676_49992">
                                                  <rect width="24" height="25" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Upload File
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              fontWeight="400"
                                              color="#2E2E3A"
                                              style={{ fontSize: "12px" }}
                                            >
                                              386x600
                                            </Typography>
                                          </div>
                                        </MDButton>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Desktop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));

                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>

                      {/* Slider */}
                      <TabPanel value="Slider" style={{ padding: "30px 0 0 0" }}>
                        <Grid container direction="row" spacing={4}>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Desktop
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  {["1", "2", "3"].map((index) => {
                                    const gridItem = Array.isArray(card?.desktopGrid)
                                      ? card.desktopGrid.find(
                                          (item) => item.index === index && item.imageUrl
                                        )
                                      : null;

                                    return (
                                      <Grid item xs={12} md={4} key={index}>
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} md={12}>
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="center"
                                              borderRadius="16px"
                                              backgroundColor="#ffffff"
                                              height="100%"
                                              minHeight="416px"
                                              position="relative"
                                            >
                                              {gridItem && (
                                                <IconButton
                                                  className="remove-icon"
                                                  size="small"
                                                  onClick={() =>
                                                    removeImageHandler(
                                                      gridItem,
                                                      "",
                                                      card?.arrayIndex
                                                    )
                                                  }
                                                >
                                                  <CloseIcon fontSize="small" />
                                                </IconButton>
                                              )}
                                              {gridItem ? (
                                                <img
                                                  src={gridItem.imageUrl}
                                                  alt="Desktop Grid"
                                                  onClick={() => {
                                                    setErrors((prev) => ({
                                                      ...prev,
                                                      [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                        "",
                                                    }));
                                                    dispatch(
                                                      openCustomModalDialog({
                                                        modal: "ADD_GRID_BANNER",
                                                        modalData: {
                                                          categoryData: gridItem,
                                                          type: "Dekstop",
                                                          dimensions: "386x600",
                                                          index,
                                                          arrayIndex: card?.arrayIndex,
                                                          handleSave: (data) => handleSave(data),
                                                        },
                                                      })
                                                    );
                                                  }}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    minHeight: "416px",
                                                    maxHeight: "416px",
                                                    borderRadius: "16px",
                                                    objectFit: "cover",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              ) : (
                                                <MDButton
                                                  sx={{ minWidth: "180px" }}
                                                  type="button"
                                                  variant="outlined"
                                                  color="secondary"
                                                  component="span"
                                                  name={`categorySection[${card?.arrayIndex}].desktopGrid`}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    padding: "0",
                                                    border: "none",
                                                    borderRadius: "0",
                                                  }}
                                                  onClick={() => {
                                                    setErrors((prev) => ({
                                                      ...prev,
                                                      [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                        "",
                                                    }));
                                                    dispatch(
                                                      openCustomModalDialog({
                                                        modal: "ADD_GRID_BANNER",
                                                        modalData: {
                                                          type: "Dekstop",
                                                          dimensions: "386x600",
                                                          index,
                                                          arrayIndex: card?.arrayIndex,
                                                          handleSave: (data) => handleSave(data),
                                                        },
                                                      })
                                                    );
                                                  }}
                                                >
                                                  <div className="add-change-img-sec">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24"
                                                      height="25"
                                                      viewBox="0 0 24 25"
                                                      fill="none"
                                                    >
                                                      <g clipPath="url(#clip0_13676_49992)">
                                                        <path
                                                          d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                          fill="#2E2E3A"
                                                        />
                                                      </g>
                                                      <defs>
                                                        <clipPath id="clip0_13676_49992">
                                                          <rect
                                                            width="24"
                                                            height="25"
                                                            fill="white"
                                                          />
                                                        </clipPath>
                                                      </defs>
                                                    </svg>
                                                    <Typography
                                                      variant="body2"
                                                      fontWeight="600"
                                                      color="#2E2E3A"
                                                      style={{ fontSize: "12px" }}
                                                    >
                                                      Upload File
                                                    </Typography>
                                                    <Typography
                                                      variant="body2"
                                                      fontWeight="400"
                                                      color="#2E2E3A"
                                                      style={{ fontSize: "12px" }}
                                                    >
                                                      386x600
                                                    </Typography>
                                                  </div>
                                                </MDButton>
                                              )}
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    );
                                  })}
                                  {Array.isArray(card?.desktopGrid) &&
                                    card.desktopGrid
                                      .filter(
                                        (item) =>
                                          !(
                                            item.index === "1" ||
                                            item.index === "2" ||
                                            item.index === "3"
                                          )
                                      )
                                      .map((index, idx) => {
                                        return (
                                          <Grid item xs={12} md={4} key={index}>
                                            <Grid container spacing={2}>
                                              <Grid item xs={12} md={12}>
                                                <Box
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  borderRadius="16px"
                                                  backgroundColor="#ffffff"
                                                  height="100%"
                                                  minHeight="416px"
                                                  position="relative"
                                                >
                                                  {index && (
                                                    <IconButton
                                                      className="remove-icon"
                                                      size="small"
                                                      onClick={() =>
                                                        removeImageHandler(
                                                          index,
                                                          "",
                                                          card?.arrayIndex
                                                        )
                                                      }
                                                    >
                                                      <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                  )}
                                                  {index ? (
                                                    <img
                                                      src={index.imageUrl}
                                                      alt="Desktop Grid"
                                                      onClick={() => {
                                                        setErrors((prev) => ({
                                                          ...prev,
                                                          [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                            "",
                                                        }));
                                                        dispatch(
                                                          openCustomModalDialog({
                                                            modal: "ADD_GRID_BANNER",
                                                            modalData: {
                                                              categoryData: index,
                                                              type: "Dekstop",
                                                              dimensions: "386x600",
                                                              index: index.index,
                                                              arrayIndex: card?.arrayIndex,
                                                              handleSave: (data) =>
                                                                handleSave(data),
                                                            },
                                                          })
                                                        );
                                                      }}
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        minHeight: "416px",
                                                        maxHeight: "416px",
                                                        borderRadius: "16px",
                                                        objectFit: "cover",
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  ) : (
                                                    <MDButton
                                                      sx={{ minWidth: "180px" }}
                                                      type="button"
                                                      variant="outlined"
                                                      color="secondary"
                                                      component="span"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        padding: "0",
                                                        border: "none",
                                                        borderRadius: "0",
                                                      }}
                                                      onClick={() => {
                                                        setErrors((prev) => ({
                                                          ...prev,
                                                          [`categorySection[${card?.arrayIndex}].desktopGrid`]:
                                                            "",
                                                        }));
                                                        dispatch(
                                                          openCustomModalDialog({
                                                            modal: "ADD_GRID_BANNER",
                                                            modalData: {
                                                              type: "Dekstop",
                                                              dimensions: "386x600",
                                                              index,
                                                              arrayIndex: card?.arrayIndex,
                                                              handleSave: (data) =>
                                                                handleSave(data),
                                                            },
                                                          })
                                                        );
                                                      }}
                                                    >
                                                      <div className="add-change-img-sec">
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="24"
                                                          height="25"
                                                          viewBox="0 0 24 25"
                                                          fill="none"
                                                        >
                                                          <g clipPath="url(#clip0_13676_49992)">
                                                            <path
                                                              d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                              fill="#2E2E3A"
                                                            />
                                                          </g>
                                                          <defs>
                                                            <clipPath id="clip0_13676_49992">
                                                              <rect
                                                                width="24"
                                                                height="25"
                                                                fill="white"
                                                              />
                                                            </clipPath>
                                                          </defs>
                                                        </svg>
                                                        <Typography
                                                          variant="body2"
                                                          fontWeight="600"
                                                          color="#2E2E3A"
                                                          style={{ fontSize: "12px" }}
                                                        >
                                                          Upload File
                                                        </Typography>
                                                        <Typography
                                                          variant="body2"
                                                          fontWeight="400"
                                                          color="#2E2E3A"
                                                          style={{ fontSize: "12px" }}
                                                        >
                                                          386x600
                                                        </Typography>
                                                      </div>
                                                    </MDButton>
                                                  )}
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        );
                                      })}
                                </Grid>
                                {sliderLength > 3 && (
                                  <Grid item xs={12}>
                                    <MDButton
                                      type="button"
                                      color="primary"
                                      size="medium"
                                      variant="outlined"
                                      sx={{
                                        fontSize: "14px",
                                        marginTop: "10px",
                                        padding: "0 5px",
                                        borderRadius: "0",
                                        border: "0 !important",
                                        opacity: "1 !important",
                                        minHeight: "auto",
                                      }}
                                      onClick={() => {
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              type: "Dekstop",
                                              dimensions: "386x600",
                                              index: String(sliderLength),
                                              // index: "4",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                    >
                                      <Icon>add</Icon>&nbsp;Add New Slide
                                    </MDButton>
                                  </Grid>
                                )}
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].desktopGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].desktopGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                              {/* mobileeeeeee */}
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Grid for Mobile
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  {["1", "2", "3"].map((index) => {
                                    const gridItem = Array.isArray(card?.mobileGrid)
                                      ? card.mobileGrid.find(
                                          (item) => item.index === index && item.imageUrl
                                        )
                                      : null;

                                    return (
                                      <Grid item xs={12} md={4} key={index}>
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} md={12}>
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="center"
                                              borderRadius="16px"
                                              backgroundColor="#ffffff"
                                              height="100%"
                                              minHeight="416px"
                                              position="relative"
                                            >
                                              {gridItem && (
                                                <IconButton
                                                  className="remove-icon"
                                                  size="small"
                                                  onClick={() =>
                                                    removeImageHandler(
                                                      gridItem,
                                                      "mobileGrid",
                                                      card?.arrayIndex
                                                    )
                                                  }
                                                >
                                                  <CloseIcon fontSize="small" />
                                                </IconButton>
                                              )}
                                              {gridItem ? (
                                                <img
                                                  src={gridItem.imageUrl}
                                                  alt="Desktop Grid"
                                                  onClick={() => {
                                                    setErrors((prev) => ({
                                                      ...prev,
                                                      [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                        "",
                                                    }));
                                                    dispatch(
                                                      openCustomModalDialog({
                                                        modal: "ADD_GRID_BANNER",
                                                        modalData: {
                                                          categoryData: gridItem,
                                                          type: "Mobile",
                                                          dimensions: "386x600",
                                                          index,
                                                          arrayIndex: card?.arrayIndex,
                                                          handleSave: (data) => handleSave(data),
                                                        },
                                                      })
                                                    );
                                                  }}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    minHeight: "416px",
                                                    maxHeight: "416px",
                                                    borderRadius: "16px",
                                                    objectFit: "cover",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              ) : (
                                                <MDButton
                                                  sx={{ minWidth: "180px" }}
                                                  type="button"
                                                  variant="outlined"
                                                  color="secondary"
                                                  component="span"
                                                  name={`categorySection[${card?.arrayIndex}].mobileGrid`}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    padding: "0",
                                                    border: "none",
                                                    borderRadius: "0",
                                                  }}
                                                  onClick={() => {
                                                    setErrors((prev) => ({
                                                      ...prev,
                                                      [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                        "",
                                                    }));
                                                    dispatch(
                                                      openCustomModalDialog({
                                                        modal: "ADD_GRID_BANNER",
                                                        modalData: {
                                                          type: "Mobile",
                                                          dimensions: "386x600",
                                                          index,
                                                          arrayIndex: card?.arrayIndex,
                                                          handleSave: (data) => handleSave(data),
                                                        },
                                                      })
                                                    );
                                                  }}
                                                >
                                                  <div className="add-change-img-sec">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24"
                                                      height="25"
                                                      viewBox="0 0 24 25"
                                                      fill="none"
                                                    >
                                                      <g clipPath="url(#clip0_13676_49992)">
                                                        <path
                                                          d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                          fill="#2E2E3A"
                                                        />
                                                      </g>
                                                      <defs>
                                                        <clipPath id="clip0_13676_49992">
                                                          <rect
                                                            width="24"
                                                            height="25"
                                                            fill="white"
                                                          />
                                                        </clipPath>
                                                      </defs>
                                                    </svg>
                                                    <Typography
                                                      variant="body2"
                                                      fontWeight="600"
                                                      color="#2E2E3A"
                                                      style={{ fontSize: "12px" }}
                                                    >
                                                      Upload File
                                                    </Typography>
                                                    <Typography
                                                      variant="body2"
                                                      fontWeight="400"
                                                      color="#2E2E3A"
                                                      style={{ fontSize: "12px" }}
                                                    >
                                                      386x600
                                                    </Typography>
                                                  </div>
                                                </MDButton>
                                              )}
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    );
                                  })}
                                  {Array.isArray(card?.mobileGrid) &&
                                    card.mobileGrid
                                      .filter(
                                        (item) =>
                                          !(
                                            item.index === "1" ||
                                            item.index === "2" ||
                                            item.index === "3"
                                          )
                                      )
                                      .map((index, idx) => {
                                        return (
                                          <Grid item xs={12} md={4} key={index}>
                                            <Grid container spacing={2}>
                                              <Grid item xs={12} md={12}>
                                                <Box
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  borderRadius="16px"
                                                  backgroundColor="#ffffff"
                                                  height="100%"
                                                  minHeight="416px"
                                                  position="relative"
                                                >
                                                  {index && (
                                                    <IconButton
                                                      className="remove-icon"
                                                      size="small"
                                                      onClick={() =>
                                                        removeImageHandler(
                                                          index,
                                                          "mobileGrid",
                                                          card?.arrayIndex
                                                        )
                                                      }
                                                    >
                                                      <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                  )}
                                                  {index ? (
                                                    <img
                                                      src={index.imageUrl}
                                                      alt="Mobile Grid"
                                                      onClick={() => {
                                                        setErrors((prev) => ({
                                                          ...prev,
                                                          [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                            "",
                                                        }));
                                                        dispatch(
                                                          openCustomModalDialog({
                                                            modal: "ADD_GRID_BANNER",
                                                            modalData: {
                                                              categoryData: index,
                                                              type: "Mobile",
                                                              dimensions: "386x600",
                                                              index: index.index,
                                                              arrayIndex: card?.arrayIndex,
                                                              handleSave: (data) =>
                                                                handleSave(data),
                                                            },
                                                          })
                                                        );
                                                      }}
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        minHeight: "416px",
                                                        maxHeight: "416px",
                                                        borderRadius: "16px",
                                                        objectFit: "cover",
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  ) : (
                                                    <MDButton
                                                      sx={{ minWidth: "180px" }}
                                                      type="button"
                                                      variant="outlined"
                                                      color="secondary"
                                                      component="span"
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        padding: "0",
                                                        border: "none",
                                                        borderRadius: "0",
                                                      }}
                                                      onClick={() => {
                                                        setErrors((prev) => ({
                                                          ...prev,
                                                          [`categorySection[${card?.arrayIndex}].mobileGrid`]:
                                                            "",
                                                        }));
                                                        dispatch(
                                                          openCustomModalDialog({
                                                            modal: "ADD_GRID_BANNER",
                                                            modalData: {
                                                              type: "Mobile",
                                                              dimensions: "386x600",
                                                              index,
                                                              arrayIndex: card?.arrayIndex,
                                                              handleSave: (data) =>
                                                                handleSave(data),
                                                            },
                                                          })
                                                        );
                                                      }}
                                                    >
                                                      <div className="add-change-img-sec">
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="24"
                                                          height="25"
                                                          viewBox="0 0 24 25"
                                                          fill="none"
                                                        >
                                                          <g clipPath="url(#clip0_13676_49992)">
                                                            <path
                                                              d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                              fill="#2E2E3A"
                                                            />
                                                          </g>
                                                          <defs>
                                                            <clipPath id="clip0_13676_49992">
                                                              <rect
                                                                width="24"
                                                                height="25"
                                                                fill="white"
                                                              />
                                                            </clipPath>
                                                          </defs>
                                                        </svg>
                                                        <Typography
                                                          variant="body2"
                                                          fontWeight="600"
                                                          color="#2E2E3A"
                                                          style={{ fontSize: "12px" }}
                                                        >
                                                          Upload File
                                                        </Typography>
                                                        <Typography
                                                          variant="body2"
                                                          fontWeight="400"
                                                          color="#2E2E3A"
                                                          style={{ fontSize: "12px" }}
                                                        >
                                                          386x600
                                                        </Typography>
                                                      </div>
                                                    </MDButton>
                                                  )}
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        );
                                      })}
                                  {sliderMobileLength > 3 && (
                                    <Grid item xs={12}>
                                      <MDButton
                                        type="button"
                                        color="primary"
                                        size="medium"
                                        variant="outlined"
                                        sx={{
                                          fontSize: "14px",
                                          marginTop: "10px",
                                          padding: "0 5px",
                                          borderRadius: "0",
                                          border: "0 !important",
                                          opacity: "1 !important",
                                          minHeight: "auto",
                                        }}
                                        onClick={() => {
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "386x600",
                                                index: String(sliderMobileLength),
                                                // index: "4",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <Icon>add</Icon>&nbsp;Add New Slide
                                      </MDButton>
                                    </Grid>
                                  )}
                                </Grid>
                                {Boolean(
                                  errors[`categorySection[${card?.arrayIndex}].mobileGrid`]
                                ) && (
                                  <FormHelperText error>
                                    {errors[`categorySection[${card?.arrayIndex}].mobileGrid`]}
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={4}>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Desktop
                                </Typography>
                                <Box position="relative">
                                  {card?.desktopBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    desktopBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.desktopBanner?.imageUrl ? (
                                    <img
                                      src={card?.desktopBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      onClick={() => {
                                        setErrors((prev) => ({
                                          ...prev,
                                          [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                            "",
                                        }));
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.desktopBanner,
                                              type: "Dekstop",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "desktopBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Dekstop",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "desktopBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].desktopBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Typography
                                  variant="body2"
                                  fontWeight="medium"
                                  color="#9A9AAF"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Category Banner For Mobile
                                </Typography>
                                <Box position="relative">
                                  {card?.mobileBanner?.imageUrl && (
                                    <IconButton
                                      className="remove-icon"
                                      size="small"
                                      onClick={() => {
                                        setFormData((prevFormData) => {
                                          const updatedFormData = { ...prevFormData };
                                          if (Array.isArray(updatedFormData.categorySection)) {
                                            updatedFormData.categorySection =
                                              updatedFormData.categorySection.map((section) => {
                                                if (section.arrayIndex === card?.arrayIndex) {
                                                  return {
                                                    ...section,
                                                    mobileBanner: {
                                                      imageUrl: "",
                                                      title: "",
                                                      description: "",
                                                      altText: "",
                                                      redirectUrl: "",
                                                    },
                                                  };
                                                }
                                                return section;
                                              });
                                          }
                                          return updatedFormData;
                                        });
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  {card?.mobileBanner?.imageUrl ? (
                                    <img
                                      src={card?.mobileBanner?.imageUrl}
                                      alt="Desktop Grid"
                                      onClick={() => {
                                        setErrors((prev) => ({
                                          ...prev,
                                          [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                            "",
                                        }));
                                        dispatch(
                                          openCustomModalDialog({
                                            modal: "ADD_GRID_BANNER",
                                            modalData: {
                                              categoryData: card?.mobileBanner,
                                              type: "Mobile",
                                              dimensions: "1392x260",
                                              index: "",
                                              categorybanner: "mobileBanner",
                                              arrayIndex: card?.arrayIndex,
                                              handleSave: (data) => handleSave(data),
                                            },
                                          })
                                        );
                                      }}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        minHeight: "160px",
                                        maxHeight: "160px",
                                        borderRadius: "16px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="16px"
                                      backgroundColor="#ffffff"
                                      width="160px"
                                      height="160px"
                                      position="relative"
                                    >
                                      <MDButton
                                        sx={{ minWidth: "100%" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        name={[
                                          `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`,
                                        ]}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                        onClick={() => {
                                          setErrors((prev) => ({
                                            ...prev,
                                            [`categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`]:
                                              "",
                                          }));
                                          dispatch(
                                            openCustomModalDialog({
                                              modal: "ADD_GRID_BANNER",
                                              modalData: {
                                                type: "Mobile",
                                                dimensions: "1392x260",
                                                index: "",
                                                categorybanner: "mobileBanner",
                                                arrayIndex: card?.arrayIndex,
                                                handleSave: (data) => handleSave(data),
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_13676_49992)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_13676_49992">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Upload File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            1392x260
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  )}
                                </Box>
                                {Boolean(
                                  errors[
                                    `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                  ]
                                ) && (
                                  <FormHelperText error>
                                    {
                                      errors[
                                        `categorySection[${card?.arrayIndex}].mobileBanner.imageUrl`
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </TabContext>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          );
        })}

        <Box display="flex" justifyContent="space-between" alignItems="center" mt={4}>
          <MDButton
            type="button"
            color="primary"
            size="medium"
            variant="outlined"
            sx={{ minWidth: "170px", fontSize: "14px" }}
            disabled={allCategoriesSelected}
            onClick={handleAddCategory}
          >
            <Icon>add</Icon>&nbsp;Add Category
          </MDButton>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default CategorySection;
